import { defineComponent as _defineComponent } from 'vue'
import { isAdmin } from '@/util/auth';
import Loader from '@/components/loader.vue';
import SimpleYesNoModal from '@/components/SimpleYesNoModal.vue';
import { onMounted, ref } from 'vue';
import { DataInstance, Userspaces } from '@busy-human/opt-library';
import { useRoute, useRouter } from 'vue-router';
import { auth } from '@/util/firebase';
import { useUserspace } from '@/store/userspace';


export default /*#__PURE__*/_defineComponent({
  __name: 'proxy',
  setup(__props, { expose }) {
  expose();

if(!isAdmin.value) console.error("ADMIN PROXY PAGE ACCESSED BY NON-ADMIN!", "This page will likely misbehave.")

const users = ref<DataInstance<Userspaces.Model>[]>([]);

const route = useRoute();
const router = useRouter();

onMounted(async () => {
    const res = await Userspaces.Collection.fetchAll();
    const authedUser = auth.currentUser?.uid;
    users.value = res.dataItems().filter(a => a.$id !== authedUser).sort((a, b) => a.name.fullName.localeCompare(b.name.fullName));
    loading.value = false;

    const uid = route.query['uid'];

    if(uid) {
        const tmp = users.value.find(user => user.$id === uid);
        showConfirmFor.value = tmp || null;
    }
})

const loading = ref(true);
const showConfirmFor = ref<DataInstance<Userspaces.Model> | null>(null)
const performProxy = async (user: DataInstance<Userspaces.Model>) => {
    console.log("Changing to user", user.$id);
    const userspace = useUserspace();
    loading.value = true;
    await userspace.setUserId(user.$id, true)
    loading.value = false;
    console.log("Successfully proxied.", userspace.user.name.fullName);
    await router.push("/");
}


const __returned__ = { users, route, router, loading, showConfirmFor, performProxy, isAdmin, Loader, SimpleYesNoModal, onMounted, ref, DataInstance, Userspaces, useRoute, useRouter, auth, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})